module.exports = __webpack_public_path__ + "static/media/about.839e7fc9.png";